import { axiosInstance } from '../api';

export default function() {
    return axiosInstance.post('/api/auth/logout');
}